import './CorrespondenceFilterModal.sass';
import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Modal from 'Shared/components/Modal';
import { Button, Tooltip } from '@material-ui/core';
import { changeAnalyticsState } from 'Core/ducks/analytics';
import { ReducerState } from 'rootReducer';
import { ANALYTICS_EVENT_ACTION } from 'Core/components/Analytics/AnalyticsEventConstants';
import PolicyRouteConstants from '../PolicyRouteConstants';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { changeCorrespondenceFilter } from '../ducks/policyCorrespondence';
import Alert from '@material-ui/lab/Alert';

type CorrespondenceFilterModalProps = {
  hideModal: () => void;
} & RouteComponentProps;

export const CorrespondenceFilterModal = (props: CorrespondenceFilterModalProps) => {
  const dispatch = useDispatch();
  const {analytics} = useSelector((state: ReducerState) => state.analytics);
  const [searchCriteriaValue, setSearchCriteriaValue] = useState({accountNumber:'', policyNumber:''});

  const updateFilterValue = (label:string, value: string) => {
    setSearchCriteriaValue(values=>({
      ...values,
      [label]: value
    }))
  }

  const emptyFilter = Object.values(searchCriteriaValue).every(
    value => value === ''
  );

  return (
    <Modal title="Select Correspondence By" open onClose={props.hideModal} disableBackdropClick>
      <div className='correspondence__body'>
        <Alert severity="info">
            Filter using either Account Number or Policy Number.
        </Alert>
        <div className='modal-filter-body'>
          <div className='filters'>
            <div className='column-filter'>
              <div className={`filter-label ${!searchCriteriaValue.policyNumber?"":"disabled"}`}>Account Number</div>
              <Tooltip title="Billing Account Number" aria-label="info">
                <input 
                  className='account__number'
                  type="text" 
                  onChange={e=>updateFilterValue("accountNumber", e.target.value)} 
                  placeholder="Enter Account Number"
                  disabled={searchCriteriaValue.policyNumber.length!=0}/>
              </Tooltip>
            </div>
            <div className='column-filter'>
              <div className={`filter-label ${!searchCriteriaValue.accountNumber?"":"disabled"}`}>Policy Number</div>
              <input 
                className='policy__number'
                type="text" 
                onChange={e=>updateFilterValue("policyNumber", e.target.value)} 
                placeholder="Enter Policy Number"
                disabled={searchCriteriaValue.accountNumber.length!=0}/>
            </div>
          </div>
        </div>
      </div>
      <div className='filter__buttons'>
        <Button
        variant="contained" onClick={props.hideModal}>Cancel</Button>
        <Button
        variant="contained"
        disabled={emptyFilter}
        onClick={() => {
          props.hideModal();
          dispatch(
            changeAnalyticsState({
              page: analytics.page,
              ctaResponse: {eventAction: ANALYTICS_EVENT_ACTION.AGND_VIEW_CORRESPONDENCE_CLICK},
            })
          );
          dispatch(changeCorrespondenceFilter(searchCriteriaValue));
          props.history.push(PolicyRouteConstants.CORRESPONDENCE_SUMMARIES(searchCriteriaValue.policyNumber, searchCriteriaValue.accountNumber));
        }}
        color="primary">Search & Filter</Button>
      </div>
    </Modal>
  );
};

export default withRouter(CorrespondenceFilterModal);
